// extracted by mini-css-extract-plugin
module.exports = {"queue-threshold-reached":"queue-stats_queue-threshold-reached__1p784"};